import { NgModule } from '@angular/core';
import { CommunityComponent } from './community/community.component';
import { SharedModule } from '../shared/shared.module';
import { HomeComponent } from './home/home.component';
import { OrderModule } from './order/order.module';


@NgModule({
  imports: [
    SharedModule,
    OrderModule
  ],
  declarations: [CommunityComponent, HomeComponent],
  exports: [
      HomeComponent,
      CommunityComponent,
      OrderModule
  ]
})
export class ViewsModule { }
